"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPayCodePolicyModalContent = exports.PAY_CODE_INFO_TEST_ID = exports.PAY_CODE_POLICY_ENTRY_TEST_ID = void 0;
const Button_1 = require("@amzn/atoz-web/Button");
const Text_1 = require("@amzn/atoz-web/Text");
const Hr_1 = require("@amzn/atoz-web/Hr");
const View_1 = require("@amzn/atoz-web/View");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Col_1 = require("@amzn/atoz-web/Col");
const Spacer_1 = require("@amzn/atoz-web/Spacer");
const react_1 = __importDefault(require("react"));
exports.PAY_CODE_POLICY_ENTRY_TEST_ID = 'pay-code-policy-entry';
exports.PAY_CODE_INFO_TEST_ID = 'pay-code-info';
const renderPayCodePolicyModalContent = (payCodePolicyInfo, payCodesInfo) => {
    const renderLastRevisedAtText = () => (react_1.default.createElement(Col_1.Col, { alignItems: "end" },
        react_1.default.createElement(Text_1.Text, null,
            react_1.default.createElement("em", null,
                "Last Revised At: ",
                payCodePolicyInfo.lastRevisedAtDate))));
    const renderPayCodePolicyEntry = (payCodePolicy) => (react_1.default.createElement(View_1.View, { dataTestId: exports.PAY_CODE_POLICY_ENTRY_TEST_ID, key: payCodePolicy.payCode },
        react_1.default.createElement(Text_1.H3, { fontSize: 'T300', fontWeight: 'bold' }, payCodePolicy.payCode),
        react_1.default.createElement(Text_1.Text, { fontSize: 'T200', lineHeight: '24px' }, payCodePolicy.policyText),
        react_1.default.createElement(Spacer_1.Spacer, { height: 10 }),
        react_1.default.createElement(Hr_1.Hr, null),
        react_1.default.createElement(Spacer_1.Spacer, { height: 10 })));
    const renderPayCodeEntry = (payCode) => (react_1.default.createElement(View_1.View, { dataTestId: exports.PAY_CODE_INFO_TEST_ID, key: payCode.description },
        react_1.default.createElement(Text_1.H3, { fontSize: 'T300', fontWeight: 'bold' }, payCode.description),
        react_1.default.createElement(Text_1.Text, { fontSize: 'T200', lineHeight: '24px' }, payCode.policyText),
        react_1.default.createElement(Spacer_1.Spacer, { height: 10 }),
        react_1.default.createElement(Hr_1.Hr, null),
        react_1.default.createElement(Spacer_1.Spacer, { height: 10 })));
    const renderModalFunction = ({ close }) => (react_1.default.createElement(Modal_1.ModalContent, { titleText: "Types of Working Hours", buttons: [
            react_1.default.createElement(Button_1.Button, { key: "Done", onClick: close, variant: Button_1.ButtonVariant.Primary }, "Done")
        ], closeButtonAriaDescribedBy: 'Close' },
        !!payCodePolicyInfo && renderLastRevisedAtText(),
        !!payCodePolicyInfo &&
            payCodePolicyInfo.payCodePolicies.map((payCodePolicy) => renderPayCodePolicyEntry(payCodePolicy)),
        !!payCodesInfo &&
            payCodesInfo.payCodes.map((payCode) => renderPayCodeEntry(payCode))));
    return renderModalFunction;
};
exports.renderPayCodePolicyModalContent = renderPayCodePolicyModalContent;
